module.exports = __webpack_public_path__ + "b0e19fde0df5ee8730322578f14ff9ba.png";